import React from "react";
import "../../Styles/Purchaseorder.css";

const FormField = ({ label, type = "text", placeholder }) => (
    <div className="form-field">
        <input type={type} placeholder={placeholder} className="input" />
    </div>
);

const BuildingPacking = () => {
    return (
        <div className="purchase-order-form">
            <div className="card" >
                <h2>Create Bundle / Pack</h2>

                <div className="form-grid">
                    <FormField placeholder="Bundle Name" />
                    <FormField placeholder="Bundle Quantity" />
                    <FormField placeholder="Warehouse" />
                </div>

                <h3>Items to Bundle</h3>

                <div className="items-row">
                    {["FG Item", "Qty", "Unit"].map((field) => (
                        <div className="raw-field" key={field}>
                            <input type="text" placeholder={field} className="input" />
                        </div>
                    ))}
                </div>

                <div className="form-buttons">
                    <button className="btn submit">Create Bundle</button>
                </div>
            </div>
        </div>
    );
};

export default BuildingPacking;
